import { createContext, useContext } from 'react';
import type { ToastContextType } from './types';

export const ToastContext = createContext<ToastContextType | undefined>(
  undefined
);

export default function useToast() {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
}
